import React, {
    useCallback, useEffect, useRef, useState, Suspense,
} from 'react';
import Row from 'antd/es/grid/row';
import Col from 'antd/es/grid/col';
import Dropdown from '../CustomDropdown/Dropdown';
import SupportDropdown from './SupportDropdown';
import { TopBarSupport } from '../icons/TopBarSupport';

function Support() {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleDropdown = useCallback(
        (visible: boolean) => {
            setDropdownOpen(visible);
        },
        [],
    );
    
    return (
        <Row>
            <Col xs={24}>
                <Dropdown
                    overlay={(
                        <Suspense fallback={null}>
                            <SupportDropdown/>
                        </Suspense>
                    )}
                    trigger={['click']}
                    className="gx-pointer"
                    placement="bottomRight"
                    overlayStyle={{ zIndex: 10001 }}
                    visible={dropdownOpen}
                    onVisibleChange={handleDropdown}
                >
                    <div className="gx-d-flex gx-align-items-center gx-position-relative custom-navbar__menu-item gx-text-nowrap">
                        <TopBarSupport/>
                        {window.location.pathname !== '/' ? null : 'Служба поддержки'}
                    </div>
                </Dropdown>
            </Col>
        </Row>
    )
}

export default Support;